import SitePage from "@/components/application/site-page";
import { ReactNode } from "react";

function TermsPage() {
  return (
    <>
      <h1>Términos y Condiciones</h1>
      <p>
        <strong>Última actualización:</strong> 26 de julio de 2026
      </p>

      <p>
        ¡Bienvenido a <strong>BrickGestor</strong>! Estos Términos y
        Condiciones explican cómo puedes usar nuestro servicio. Al acceder o
        usar BrickGestor, aceptas estos términos. Si no estás de acuerdo, por
        favor no uses el servicio.
      </p>

      <h2>1. Quiénes somos</h2>
      <p>
        BrickGestor es una plataforma de software que ayuda a vendedores de
        LEGO y AFOLs a gestionar inventario, precios y ventas de forma
        interna.
      </p>
      <p>
        BrickGestor es operado por{" "}
        <strong>Gatito Pirata Technologies EIRL</strong>, una empresa
        organizada bajo las leyes de Perú, RUC 20616175221.
      </p>
      <p>
        BrickGestor <strong>no es un marketplace</strong> y no procesa pagos
        entre vendedores y compradores.
      </p>

      <h2>2. Quién puede usar BrickGestor</h2>
      <p>
        Debes tener al menos 18 años y capacidad legal para celebrar
        contratos para usar BrickGestor.
      </p>

      <h2>3. Tu cuenta</h2>
      <p>
        Para usar la mayoría de las funciones, necesitas crear una cuenta.
        Eres responsable de:
      </p>
      <ul>
        <li>Proporcionar información precisa</li>
        <li>Mantener seguros los datos de tu inicio de sesión</li>
        <li>Toda actividad que ocurra bajo tu cuenta</li>
      </ul>

      <h2>4. Planes, precios y pagos</h2>
      <p>
        BrickGestor ofrece planes gratuitos y de pago. Las funciones,
        límites y precios se muestran en nuestro sitio web.
      </p>
      <p>
        Los planes de pago se facturan por adelantado de forma recurrente
        (mensual o anual). Si un pago falla, el acceso a las funciones de
        pago puede pausarse.
      </p>

      <h2>5. Planes gratuitos y límites</h2>
      <p>
        Los planes gratuitos o de prueba pueden tener límites (por ejemplo,
        número de productos, usuarios o funciones).
      </p>
      <p>
        Podemos cambiar o descontinuar los planes gratuitos en cualquier
        momento.
      </p>

      <h2>6. Tus datos</h2>
      <p>
        Eres dueño de todos los datos que subas a BrickGestor, incluyendo
        inventario, precios y descripciones.
      </p>
      <p>
        Al usar BrickGestor, nos permites almacenar y procesar tus datos
        solo según sea necesario para operar y mejorar el servicio.
      </p>
      <p>
        Los datos personales se procesan de acuerdo con la Ley N.° 29733,
        Ley de Protección de Datos Personales, según se describe en nuestra{" "}
        <a href="/privacy">Política de Privacidad</a>.
      </p>
      <p>
        Eres responsable de asegurarte de que tus datos sean precisos y
        lícitos.
      </p>

      <h2>7. Lo que no puedes hacer</h2>
      <p>Por favor, no uses BrickGestor para:</p>
      <ul>
        <li>Infringir la ley o cometer fraude</li>
        <li>Atacar, sobrecargar o hacer ingeniería inversa del servicio</li>
        <li>Subir malware o contenido dañino</li>
        <li>Acceder a cuentas o datos que no son tuyos</li>
      </ul>

      <h2>8. Disponibilidad del servicio</h2>
      <p>
        Hacemos nuestro mejor esfuerzo para mantener BrickGestor funcionando
        sin problemas, pero no podemos garantizar que siempre esté
        disponible o libre de errores.
      </p>
      <p>
        Podemos realizar mantenimiento, actualizaciones o cierres
        temporales cuando sea necesario.
      </p>

      <h2>9. Propiedad intelectual</h2>
      <p>
        BrickGestor, incluyendo su software, marca y diseño, pertenece a
        <strong> Gatito Pirata Technologies EIRL</strong>.
      </p>
      <p>
        No puedes copiar, revender ni hacer mal uso de ninguna parte del
        servicio sin autorización.
      </p>

      <h2>10. Cancelación y terminación</h2>
      <p>Puedes cancelar tu cuenta en cualquier momento.</p>
      <p>
        Podemos suspender o cerrar cuentas si se violan estos términos o si
        hay tarifas pendientes de pago.
      </p>

      <h2>11. Descargo de responsabilidad</h2>
      <p>
        BrickGestor se proporciona "tal cual" y "según disponibilidad". No
        garantizamos que se ajuste a cada caso de uso específico ni que
        siempre esté disponible sin interrupciones.
      </p>

      <h2>12. Responsabilidad</h2>
      <p>
        En la máxima medida permitida por la ley, BrickGestor y Gatito
        Pirata Technologies EIRL no son responsables de daños indirectos o
        consecuentes, pérdida de ganancias o pérdida de datos.
      </p>
      <p>
        Nuestra responsabilidad total no excederá el monto que nos hayas
        pagado en los últimos 12 meses.
      </p>

      <h2>13. Derechos del consumidor (Perú)</h2>
      <p>
        Nada en estos términos limita tus derechos bajo las leyes peruanas
        de protección al consumidor, incluyendo la Ley N.º 29571.
      </p>

      <h2>14. Cambios a estos términos</h2>
      <p>
        Podemos actualizar estos Términos y Condiciones de vez en cuando.
        Cuando lo hagamos, actualizaremos la fecha en la parte superior de
        esta página.
      </p>
      <p>
        Continuar usando BrickGestor significa que aceptas los términos
        actualizados.
      </p>

      <h2>15. Ley y jurisdicción</h2>
      <p>Estos términos se rigen por las leyes de la República del Perú.</p>
      <p>
        Cualquier disputa será resuelta por los tribunales de Lima, Perú, a
        menos que la ley del consumidor exija lo contrario.
      </p>

      <h2>16. Contacto</h2>
      <p>
        Si tienes preguntas sobre estos términos, puedes contactarnos en:
      </p>
      <p>
        <strong>Gatito Pirata Technologies EIRL</strong>
        <br />
        RUC: 20616175221
        <br />
        Correo: brickgestor@gatitopirata.com
      </p>

      <p>
        <em>
          BrickGestor es un producto independiente y no está afiliado ni
          respaldado por el Grupo LEGO.
        </em>
      </p>
    </>
  );
}

TermsPage.layout = (page: ReactNode) => <SitePage children={page} />;

export default TermsPage;
